export const serviceAreasData = [
  "Bowral ",
  "Bargo ",
  "Wilton ",
  "Picton ",
  "Appin ",
  "Camden ",
  "Werombi ",
  "Menangle ",
  "Campbelltown ",
  "Oran park ",
  "Narellan ",
  "Minto ",
  "Gregory hills ",
  "Gledswood hills ",
  "Bardia ",
  "Edmondson park ",
  "Holsworthy ",
  "Heathcote ",
  "Liverpool ",
  "Casula ",
  "Moorebank ",
  "Ingleburn ",
  "Hoxton park ",
  "Austral ",
  "Wattle grove",
  "Peakhurst ",
  "Revesby",
  "Chipping norton ",
  "Bankstown ",
  "Sutherland ",
  "Kurnell",
  "Engadine ",
  "Cronulla ",
  "Kirrawee ",
  "Gymea",
  "Bundeena",
  "Panania ",
  "East hills ",
  "Brighton-le-sands",
  "Sans Souci",
  "Kograh ",
  "Rockdale ",
  "Maroubra ",
  "Randwick ",
  "Bondi ",
  "Vaucluse ",
  "Coogee",
  "Concord ",
  "Blake hurst",
  "Mortdale ",
  "Gladesville ",
  "Ryde ",
  "Homebush ",
  "Sydney Olympic Park",
  "Strathfield",
  "Drummoyne ",
  "Eastern Creek ",
  "Wetherill Park ",
  "Westmead ",
  "Parramatta ",
  "Burwood ",
  "Lidcombe ",
  "Wentworthville ",
  "Rhodes ",
  "Clyde ",
  "Chatswood ",
  "Macquarie Park ",
  "Epping ",
  "Penant hills ",
  "St Leonard ",
  "Lane cove ",
  "Roseville",
  "Frenchs Forest",
  "Cromer",
  "Narrabeen ",
  "Burraneer",
  "Turramurra",
  "Gordon",
  "Wahroonga",
  "Pymble ",
  "Thornleigh",
  "Eastwood",
  "Castle hill",
  "Kellyville",
  "Rouse hill ",
  "Blacktown",
  "Richmond ",
  "Box hill ",
  "The ponds",
  "Marsden park ",
  "Penrith",
  "Northmead",
  "Rydalmere",
  "Dural",
  "Asquith ",
  "Hornsby ",
  "Berowra",
  "St ives ",
  "Denistone ",
  "Belrose",
  "Terrey Hills ",
  "Mona vale ",
  "Bayview ",
  "Newport ",
  "Palm beach ",
  "Avalon ",
  "Warriewood ",
  "Bilgola",
  "Brookvale",
  "Church point ",
  "Balgowlah ",
  "Freshwater ",
  "Manly ",
  "Seaforth ",
  "Allambie heights ",
  "Mosman",
  "Neutral bay ",
  "Willoughby",
  "Castlecrag",
  "Castle cove ",
  "Killarney heights ",
  "North sydney ",
  "Riverview",
  "Milsons Point ",
  "Greenwich ",
  "Millers point",
  "Barangroo",
  "The rocks",
  "Dee why ",
  "Westmead",
  "Watsons bay ",
  "Double bay ",
  "Bondi ",
  "Coogee",
  "Clovelly ",
  "Paddington ",
  "Mascot",
];
